
import React from 'react';
import { BookingDetails } from "@/hooks/bookings/types";
import QuotesSection from "./QuotesSection";

interface QuotesTabProps {
  booking: BookingDetails;
  quotes: any[];
  onQuoteUpdate: () => Promise<void>;
  onBookingUpdate?: (bookingId: string) => Promise<void>;
  isAdmin: boolean;
  isBookingOwner: boolean;
}

const QuotesTab: React.FC<QuotesTabProps> = ({
  booking,
  quotes,
  onQuoteUpdate,
  onBookingUpdate,
  isAdmin,
  isBookingOwner
}) => {
  return (
    <div className="space-y-6 px-4">
      <QuotesSection 
        bookingId={booking.id} 
        quotes={quotes} 
        isAdmin={isAdmin} 
        isBookingOwner={isBookingOwner}
        onQuoteUpdate={onQuoteUpdate} 
      />
    </div>
  );
};

export default QuotesTab;
